import { Component, OnInit, OnDestroy } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { AuthService } from '../../services/auth.service';
import { OverlayService } from '../../services/overlay.service';
import { sortByProp } from '../../utils/array';
import { NewApiResponse } from '../../services/new-api-http.service';
import { fadeAnimation } from '../../animations';
import { Router } from '@angular/router';
import { BeeFreeService } from '../../services/beefree.service';
import { Subscription } from 'rxjs';
import { MaintenanceService } from '../../services/maintenance.service';

@Component({
	selector: 'app-new-component',
	templateUrl: './component-new.component.html',
	styleUrls: ['./component-new.component.scss'],
	animations: [fadeAnimation]
})
export class ComponentNewComponent implements OnInit, OnDestroy {
	createComponentFilter;
	componentList = [];
	componentListBank = [];
	filterByName: string;
	public loading = true;
	mainHeight = window.innerHeight - 127;
	isBeeFree: boolean;
	data$;
	isAdmin: boolean;
	supportedComponentsSub: Subscription;

	constructor(
		private component: ComponentService,
		private auth: AuthService,
		private overlay: OverlayService,
		private router: Router,
		private beeFree: BeeFreeService,
		private maintenance: MaintenanceService
	) {
		window.addEventListener('message', this.recieveMessage.bind(this), false);
	}

	ngOnInit() {
		this.isBeeFree = this.beeFree.isBeeFreeAddon();
		this.isAdmin = this.auth.isAdmin();
		this.overlay.updateOverlay(true, 'Loading Component List...');
		this.supportedComponentsSub = this.component.getSupportedComponents().subscribe(
			(response: NewApiResponse) => {
				if (response && response.status) {
					const supportedComponents = [];
					for (const key in response.data) {
						if (response.data[key]) {
							if (
								(response.data[key].active || this.auth.isWebDeveloper()) &&
								((this.isAdmin && response.data[key].role_id >= 1) || (!this.isAdmin && response.data[key].role_id === 1))
							) {
								supportedComponents.push(response.data[key]);
							}
						}
					}

					supportedComponents.sort(sortByProp('description'));
					this.componentListBank = supportedComponents;
					this.componentList = this.componentListBank;

					this.createComponentFilter = [];
					const categories = [];

					for (const key in this.componentList) {
						if (categories.indexOf(this.componentList[key].category) === -1) {
							categories.push(this.componentList[key].category);
							this.createComponentFilter.push({ label: this.componentList[key].category, active: 0 });
						}
					}
					this.createComponentFilter.sort(sortByProp('label'));
					this.createComponentFilter.unshift({ label: 'Show All', active: 1 });

					this.overlay.updateOverlay(false);
					this.loading = false;
				}
			},
			(err) => {
				this.overlay.updateOverlay(true, JSON.stringify(err), 'alert');
				this.maintenance.serverMaintenance(err);
			}
		);
	}

	ngOnDestroy() {
		if (this.supportedComponentsSub) {
			this.supportedComponentsSub.unsubscribe();
		}
	}

	recieveMessage(message) {
		if (
			message.origin === 'https://app.getbee.io' &&
			message.data &&
			message.data.action === 'load' &&
			message.data.data.metadata?.componentID
		) {
			this.overlay.updateOverlay(true, 'Loading Component...');
			this.router.navigate(['/component/' + message.data.data.metadata.componentID]);
		}
	}

	getFilteredListByCategory(): void {
		for (const j in this.createComponentFilter) {
			if (this.createComponentFilter[j].active) {
				for (const k in this.componentListBank) {
					if (this.componentListBank && this.componentListBank.hasOwnProperty(k)) {
						const catArr = this.componentListBank[k].category.split(',');
						for (const l in catArr) {
							if (catArr[l].trim() === this.createComponentFilter[j].label) {
								this.componentList.push(this.componentListBank[k]);
							}
						}
					}
				}
			}
		}

		this.componentList.sort(sortByProp('description'));
	}

	filterChangeToggle(item, event) {
		this.componentList = [];
		if (item === 0 && !event.target.className.includes('active')) {
			for (const i in this.createComponentFilter) {
				if (this.createComponentFilter[i]) {
					this.createComponentFilter[i].active = 0;
				}
				if (parseInt(i) > 0) {
					const selectedCompTypes: HTMLElement = document.getElementById('createComponentFilterLabel' + i);
					selectedCompTypes.classList.remove('active');
				} else {
					if (event.srcElement.localName === 'a') {
						const selectedCompTypesQ: HTMLElement = document.getElementById('createComponentFilterLabel0');
						selectedCompTypesQ.classList.add('active');
					}
				}
			}
			this.createComponentFilter[0].active = 1;
			this.componentList = this.componentListBank;
			this.onClearFilterByName();
		} else if (item !== 0 && event.target.className.includes('active')) {
			this.createComponentFilter[item].active = 0;
			var showAll = 0;
			const listOfLabels = document.getElementsByClassName('selectComponentListLabel');
			for (var i = 1; i < listOfLabels.length; i++) {
				if (listOfLabels[i].classList.contains('active')) {
					showAll += 1;
				}
			}
			if (showAll == 1) {
				this.createComponentFilter[0].active = 1;
				this.componentList = this.componentListBank;
			}
		} else if (item !== 0 && !event.target.className.includes('active')) {
			this.createComponentFilter[item].active = 1;
			this.createComponentFilter[0].active = 0;
			const selectedCompTypes: HTMLElement = document.getElementById('createComponentFilterLabel0');
			selectedCompTypes.classList.remove('active');
		} else {
			this.createComponentFilter[0].active = 0;
		}
		this.getFilteredListByCategory();
	}

	filterChange(item, event) {
		this.componentList = [];

		if (item === 0 && event.target.checked) {
			for (const i in this.createComponentFilter) {
				if (this.createComponentFilter[i]) {
					this.createComponentFilter[i].active = 0;
				}
			}

			this.createComponentFilter[0].active = 1;
			this.componentList = this.componentListBank;
		} else if (item !== 0 && event.target.checked) {
			this.createComponentFilter[0].active = 0;
		}

		this.createComponentFilter[item].active = +event.target.checked;
		this.getFilteredListByCategory();
	}

	onFilterByNameChange(query: any): void {
		this.filterByName = query;

		if (query.length) {
			this.componentList = this.componentListBank.filter((component: any): boolean => {
				const componentName: string = component.description;
				return componentName.toLowerCase().indexOf(query.toLowerCase()) > -1;
			});
			this.componentList.sort(sortByProp('description'));
		} else {
			this.onClearFilterByName();
		}
	}

	onClearFilterByName() {
		this.filterByName = '';
		const filterCategoryIndex: number = this.createComponentFilter.findIndex((filter) => filter.active);
		this.filterChange(filterCategoryIndex, { target: { checked: true } });
	}
}
